import { Box, Button, Grid, IconButton, Paper } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import MaterialTable from "material-table";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import FormAddService from "./components/FormAddService";
import FormEditBannerService from "./components/FormEditBannerService";
import { swalCondition } from "../../../../utils/swalHelper";
import {
    getBannerColumns,
    getColumns,
    initialBannerTableOptions,
    initialTableOptions,
    styles,
} from "./helpers/serviceManageOption";
import { uniqueId } from "lodash";
import { toImageUrl } from "../../../../utils/formatHelper";
import dateformat from "dateformat";
import { uploadImageFile } from "../../../../api/uploadApi";
import { initialValues } from "./helpers/formAddServiceOption";
import { initialBannerValues } from "./helpers/formEditBannerServiceOption";
import {
    createMarketingServiceBanner,
    deleteMarketingServiceBannerById,
    getAllMarketingServiceBanner,
    updateMarketingServiceBannerById,
} from "../../../../api/marketingServiceBannerApi";
import {
    createMarketingService,
    deleteMarketingServiceById,
    getAllMarketingService,
    updateMarketingServiceById,
} from "../../../../api/marketingServiceApi";
import { useSelector } from "react-redux";

export default function ServiceManage() {
    const classes = styles();

    // ref
    const controllerRef = useRef(null);
    const tableRef = useRef(null);
    const bannerTableRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    const [isOpenFormAdd, setIsOpenFormAdd] = useState(false);
    const [isOpenFormBanner, setIsOpenFormBanner] = useState(false);
    const [tabKey, setTabKey] = useState("all");
    const [tableOptions, setTableOptions] = useState(initialTableOptions);
    const [bannerTableOptions, setBannerTableOptions] = useState(initialBannerTableOptions);
    const [initailFormValues, setInitailFormValues] = useState(initialValues);
    const [initailBannerFormValues, setInitailBannerFormValues] = useState(initialBannerValues);
    const [isCreateMode, setIsCreateMode] = useState(false);
    const [isBannerCreateMode, setIsBannerCreateMode] = useState(false);

    const handleSelectTab = useCallback(async key => {
        setTabKey(key);
    }, []);

    // upload image logic
    const handleUploadImage = useCallback(async imageArray => {
        try {
            let imagePathArray = [];
            for await (const image of imageArray) {
                if (image?.file) {
                    const formData = new FormData();
                    formData.append("image", image?.file);
                    const imagePath = await uploadImageFile(formData, controllerRef.current?.signal);
                    imagePathArray.push(imagePath);
                } else {
                    imagePathArray.push(image?.name);
                }
            }
            return imagePathArray;
        } catch (error) {
            console.dir(error);
        }
    }, []);

    /** Start All Tab */
    // fetch data
    const fetchData = useCallback(async query => {
        try {
            const queryParams = {
                page: query?.page + 1 || 1,
                limit: query?.pageSize || 10,
                search: query?.search || "",
                order: query?.orderBy?.field || "marketingServiceId",
                direction: query?.orderBy?.field ? query?.orderDirection : "desc",
            };
            const res = await getAllMarketingService(queryParams, controllerRef.current?.signal);
            if (res) {
                setTableOptions(currentState => ({
                    ...currentState,
                    currentPage: query?.page,
                    pageSize: query?.pageSize || 10,
                    totalData: res?.pagination?.totalData || 0,
                    order: query?.orderBy?.field || "timestamp",
                    direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                }));
                return {
                    data: res?.data || [],
                    page: query?.page || 0,
                    totalCount: res?.pagination?.totalData || 0,
                };
            }
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        } catch (error) {
            console.dir(error);
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
    }, []);

    // set formik value
    const setFormValues = useCallback(newsEvent => {
        setInitailFormValues({
            marketingServiceId: newsEvent?.marketingServiceId,
            titleTh: newsEvent?.titleTh || "",
            titleEn: newsEvent?.titleEn || "",
            startDate: newsEvent?.startDate ? new Date(newsEvent?.startDate) : new Date(),
            endDate: newsEvent?.endDate ? new Date(newsEvent?.endDate) : new Date(),
            fileImages: newsEvent?.image
                ? [
                      {
                          id: uniqueId(),
                          name: newsEvent?.image,
                          src: toImageUrl(newsEvent?.image),
                      },
                  ]
                : [],
            fileIcons: newsEvent?.iconImage
                ? [
                      {
                          id: uniqueId(),
                          name: newsEvent?.iconImage,
                          src: toImageUrl(newsEvent?.iconImage),
                      },
                  ]
                : [],
            contentEn: newsEvent?.contentEn || "",
            contentTh: newsEvent?.contentTh || "",
        });
    }, []);

    // clear formik value
    const clearFormValues = useCallback(() => {
        setInitailFormValues({
            title: "",
            startDate: new Date(),
            endDate: new Date(),
            fileImage: [],
            fileThumb: [],
            textEditor: "",
        });
    }, []);

    // open modal create form
    const handleOpenCreateForm = useCallback(() => {
        clearFormValues();
        setIsCreateMode(true);
        setIsOpenFormAdd(true);
    }, [clearFormValues]);

    // open modal edit form
    const handleOpenEditForm = useCallback(
        newsEvent => {
            setFormValues(newsEvent);
            setIsCreateMode(false);
            setIsOpenFormAdd(true);
        },
        [setFormValues],
    );

    // close modal
    const handleCloseForm = useCallback(() => {
        clearFormValues();
        setIsCreateMode(false);
        setIsOpenFormAdd(false);
    }, [clearFormValues]);

    // create logic
    const handleCreateService = useCallback(
        async newsEvent => {
            try {
                let imagePath = "";
                if (newsEvent?.fileImages?.length) {
                    const imagePathArray = await handleUploadImage(newsEvent?.fileImages);
                    imagePath = imagePathArray[0];
                }
                let iconPath = "";
                if (newsEvent?.fileIcons?.length) {
                    const imagePathArray = await handleUploadImage(newsEvent?.fileIcons);
                    iconPath = imagePathArray[0];
                }
                const createBody = {
                    titleTh: newsEvent?.titleTh,
                    titleEn: newsEvent?.titleEn,
                    contentTh: newsEvent?.contentTh,
                    contentEn: newsEvent?.contentEn,
                    startDate: newsEvent?.startDate ? dateformat(newsEvent?.startDate, "yyyy-mm-dd") : "",
                    endDate: newsEvent?.endDate ? dateformat(newsEvent?.endDate, "yyyy-mm-dd") : "",
                    iconImage: iconPath,
                    image: imagePath,
                };
                const isCreate = await createMarketingService(createBody, controllerRef.current?.signal);
                if (isCreate) {
                    tableRef.current.onQueryChange();
                    setIsOpenFormAdd(false);
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [handleUploadImage],
    );

    // update logic
    const handleUpdateService = useCallback(
        async newsEvent => {
            try {
                let imagePath = "";
                if (newsEvent?.fileImages?.length) {
                    const imagePathArray = await handleUploadImage(newsEvent?.fileImages);
                    imagePath = imagePathArray[0];
                }
                let iconPath = "";
                if (newsEvent?.fileIcons?.length) {
                    const imagePathArray = await handleUploadImage(newsEvent?.fileIcons);
                    iconPath = imagePathArray[0];
                }
                const updateBody = {
                    titleTh: newsEvent?.titleTh,
                    titleEn: newsEvent?.titleEn,
                    contentTh: newsEvent?.contentTh,
                    contentEn: newsEvent?.contentEn,
                    startDate: newsEvent?.startDate ? dateformat(newsEvent?.startDate, "yyyy-mm-dd") : "",
                    endDate: newsEvent?.endDate ? dateformat(newsEvent?.endDate, "yyyy-mm-dd") : "",
                    iconImage: iconPath,
                    image: imagePath,
                };
                const isUpdate = await updateMarketingServiceById(
                    newsEvent?.marketingServiceId,
                    updateBody,
                    controllerRef.current?.signal,
                );
                if (isUpdate) {
                    tableRef.current.onQueryChange();
                    setIsOpenFormAdd(false);
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [handleUploadImage],
    );

    // change status logic
    const handleChangeStatus = useCallback(async ({ checked, id }) => {
        try {
            const isUpdate = await updateMarketingServiceById(id, { status: checked }, controllerRef.current?.signal);
            if (isUpdate) {
                tableRef.current.onQueryChange();
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // delete logic
    const handleDeleteService = useCallback(async data => {
        const isConfirm = await swalCondition("<div class='h3 t-text-primary'>Are you delete?</div>", "", {
            icon: "error",
        });
        if (isConfirm) {
            const isDelete = await deleteMarketingServiceById(data?.marketingServiceId, controllerRef.current?.signal);
            if (isDelete) {
                tableRef.current.onQueryChange();
            }
        }
    }, []);
    /** End All Tab */

    /** Start Banner Tab */
    // fetch banner data
    const fetchBannerData = useCallback(async query => {
        try {
            const queryParams = {
                page: query?.page + 1 || 1,
                limit: query?.pageSize || 10,
                search: query?.search || "",
                order: query?.orderBy?.field || "marketingServiceBannerId",
                direction: query?.orderBy?.field ? query?.orderDirection : "desc",
            };
            const res = await getAllMarketingServiceBanner(queryParams, controllerRef.current?.signal);
            if (res) {
                setBannerTableOptions(currentState => ({
                    ...currentState,
                    currentPage: query?.page,
                    pageSize: query?.pageSize || 10,
                    totalData: res?.pagination?.totalData || 0,
                    order: query?.orderBy?.field || "timestamp",
                    direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                }));
                return {
                    data: res?.data || [],
                    page: query?.page || 0,
                    totalCount: res?.pagination?.totalData || 0,
                };
            }
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        } catch (error) {
            console.dir(error);
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
    }, []);

    // set formik banner value
    const setBannerFormValues = useCallback(service => {
        setInitailBannerFormValues({
            marketingServiceBannerId: service?.marketingServiceBannerId,
            bannerImages: service?.image
                ? [
                      {
                          id: uniqueId(),
                          name: service?.image,
                          src: toImageUrl(service?.image),
                      },
                  ]
                : [],
            bannerStartDate: service?.startDate ? new Date(service?.startDate) : new Date(),
            bannerEndDate: service?.endDate ? new Date(service?.endDate) : new Date(),
            bannerStatus: service?.status,
        });
    }, []);

    // clear formik banner value
    const clearBannerFormValues = useCallback(() => {
        setInitailBannerFormValues({
            bannerImages: [],
            bannerStartDate: new Date(),
            bannerEndDate: new Date(),
            bannerStatus: true,
        });
    }, []);

    // open modal create banner form
    const handleOpenCreateBannerForm = useCallback(() => {
        clearBannerFormValues();
        setIsBannerCreateMode(true);
        setIsOpenFormBanner(true);
    }, [clearBannerFormValues]);

    // open modal edit banner form
    const handleOpenEditBannerForm = useCallback(
        packagePromotionBanner => {
            setBannerFormValues(packagePromotionBanner);
            setIsBannerCreateMode(false);
            setIsOpenFormBanner(true);
        },
        [setBannerFormValues],
    );

    // close modal banner form
    const handleCloseBannerForm = useCallback(() => {
        clearBannerFormValues();
        setIsBannerCreateMode(false);
        setIsOpenFormBanner(false);
    }, [clearBannerFormValues]);

    // create banner logic
    const handleCreatePackagePromotionBanner = useCallback(
        async banner => {
            try {
                let bannerImagePath = "";
                if (banner?.bannerImages?.length) {
                    const imagePathArray = await handleUploadImage(banner?.bannerImages);
                    bannerImagePath = imagePathArray[0];
                }
                const createBody = {
                    image: bannerImagePath,
                    startDate: banner?.bannerStartDate,
                    endDate: banner?.bannerEndDate,
                    status: banner?.bannerStatus,
                };
                const isCreateBanner = await createMarketingServiceBanner(createBody, controllerRef.current?.signal);
                if (isCreateBanner) {
                    bannerTableRef.current.onQueryChange();
                    setIsOpenFormBanner(false);
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [handleUploadImage],
    );

    // update banner logic
    const handleUpdatePackagePromotionBanner = useCallback(
        async banner => {
            try {
                let bannerImagePath = "";
                if (banner?.bannerImages?.length) {
                    const imagePathArray = await handleUploadImage(banner?.bannerImages);
                    bannerImagePath = imagePathArray[0];
                }
                const updateBody = {
                    image: bannerImagePath,
                    startDate: banner?.bannerStartDate,
                    endDate: banner?.bannerEndDate,
                    status: banner?.bannerStatus,
                };
                const isUpdateBanner = await updateMarketingServiceBannerById(
                    banner?.marketingServiceBannerId,
                    updateBody,
                    controllerRef.current?.signal,
                );
                if (isUpdateBanner) {
                    bannerTableRef.current.onQueryChange();
                    setIsOpenFormBanner(false);
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [handleUploadImage],
    );

    // change banner status
    const handleChangeBannerStatus = useCallback(async ({ checked, id }) => {
        try {
            const isUpdate = await updateMarketingServiceBannerById(
                id,
                { status: checked },
                controllerRef.current?.signal,
            );
            if (isUpdate) {
                bannerTableRef.current.onQueryChange();
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // delete banner logic
    const handleDeletePromotionBanner = useCallback(async data => {
        const isConfirm = await swalCondition("<div class='h3 t-text-primary'>Are you delete?</div>", "", {
            icon: "error",
        });
        if (isConfirm) {
            const isDelete = await deleteMarketingServiceBannerById(
                data?.marketingServiceBannerId,
                controllerRef.current?.signal,
            );
            if (isDelete) {
                bannerTableRef.current.onQueryChange();
            }
        }
    }, []);
    /** Start Banner Tab */

    // memo
    const tableColumns = useMemo(() => getColumns({ handleChangeStatus, thisMenuPermission }), [
        handleChangeStatus,
        thisMenuPermission,
    ]);
    const bannerTableColumns = useMemo(() => getBannerColumns({ handleChangeBannerStatus, thisMenuPermission }), [
        handleChangeBannerStatus,
        thisMenuPermission,
    ]);

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, []);

    return (
        <div>
            <Box>
                <Grid container spacing={3}>
                    <Grid item xs={12} className="mb-3">
                        <h1 className="t-text-primary">Service</h1>
                    </Grid>
                    {/* phase 1 */}
                    <Grid item xs={12} className="mb-3">
                        {/* Tabs */}
                        <Tabs
                            id="control-tabs"
                            activeKey={tabKey}
                            onSelect={handleSelectTab}
                            className={classes.tabsContainer}>
                            <Tab eventKey="all" title="All" />
                            <Tab eventKey="banner" title="Banner" />
                        </Tabs>
                        {tabKey === "all" && (
                            <Paper className="p-lg-10 p-5">
                                {thisMenuPermission?.create && (
                                    <Grid container spacing={3} justify={"flex-end"}>
                                        <Grid item xs={12} md={5} xl={6}>
                                            <Box className="row align-items-center justify-content-lg-end">
                                                <div className="col-6 col-xxl-4 text-right">
                                                    <Button
                                                        onClick={handleOpenCreateForm}
                                                        className="w-100 btn t-btn-primary">
                                                        <i className="fas fa-plus" style={{ color: "inherit" }}></i>
                                                        Add
                                                    </Button>
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                )}
                                {/* table */}
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div className="t-table-custom">
                                            <MaterialTable
                                                tableRef={tableRef}
                                                components={{ Container: Box }}
                                                title=""
                                                data={fetchData}
                                                columns={tableColumns}
                                                options={tableOptions}
                                                actions={[
                                                    {
                                                        icon: "edit",
                                                        iconProps: {
                                                            style: { fontSize: 18 },
                                                            className: "action-edit",
                                                        },
                                                        tooltip: "Edit",
                                                        onClick: (event, rowData) => {
                                                            handleOpenEditForm(rowData);
                                                        },
                                                        hidden: !thisMenuPermission?.edit,
                                                    },
                                                    {
                                                        icon: "delete",
                                                        iconProps: {
                                                            style: { fontSize: 18 },
                                                            className: "action-delete",
                                                        },
                                                        tooltip: "Delete",
                                                        onClick: (event, rowData) => handleDeleteService(rowData),
                                                        hidden: !thisMenuPermission?.delete,
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Paper>
                        )}
                        {tabKey === "banner" && (
                            <Paper className="p-lg-10 p-5">
                                {thisMenuPermission?.create && (
                                    <Grid container spacing={3} justify={"flex-end"}>
                                        {/* <Grid item xs={12} md={7} xl={6}>
                                            <FormSearch onSubmit={handleClickSearch} onClear={handleClickClear} />
                                        </Grid> */}
                                        <Grid item xs={12} md={5} xl={6}>
                                            <Box className="row align-items-center justify-content-lg-end">
                                                <div className="col-6 col-xxl-4">
                                                    <Button
                                                        onClick={handleOpenCreateBannerForm}
                                                        className="w-100 btn t-btn-primary">
                                                        <i className="fas fa-plus" style={{ color: "inherit" }}></i>
                                                        Add
                                                    </Button>
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                )}
                                {/* table */}
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div className="t-table-custom">
                                            <MaterialTable
                                                tableRef={bannerTableRef}
                                                components={{ Container: Box }}
                                                title=""
                                                data={fetchBannerData}
                                                columns={bannerTableColumns}
                                                options={bannerTableOptions}
                                                actions={[
                                                    {
                                                        icon: "edit",
                                                        iconProps: {
                                                            style: { fontSize: 18 },
                                                            className: "action-edit",
                                                        },
                                                        tooltip: "Edit",
                                                        onClick: (event, rowData) => handleOpenEditBannerForm(rowData),
                                                        hidden: !thisMenuPermission?.edit,
                                                    },
                                                    {
                                                        icon: "delete",
                                                        iconProps: {
                                                            style: { fontSize: 18 },
                                                            className: "action-delete",
                                                        },
                                                        tooltip: "Delete",
                                                        onClick: (event, rowData) =>
                                                            handleDeletePromotionBanner(rowData),
                                                        hidden: !thisMenuPermission?.delete,
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Paper>
                        )}
                    </Grid>
                    {/* Modal */}
                    <Grid item xs={12}>
                        <Modal scrollable={true} show={isOpenFormAdd} size="lg" onHide={handleCloseForm}>
                            <Modal.Header>
                                <Modal.Title>{isCreateMode ? "Add" : "Edit"} Service</Modal.Title>
                                <IconButton onClick={handleCloseForm}>
                                    <Close />
                                </IconButton>
                            </Modal.Header>
                            <Modal.Body>
                                <FormAddService
                                    onCancel={handleCloseForm}
                                    onSubmit={isCreateMode ? handleCreateService : handleUpdateService}
                                    initialFormValues={initailFormValues}
                                    isCreateMode={isCreateMode}
                                />
                            </Modal.Body>
                        </Modal>
                    </Grid>
                    <Grid item xs={12}>
                        <Modal scrollable={true} show={isOpenFormBanner} size="lg" onHide={handleCloseBannerForm}>
                            <Modal.Header>
                                <Modal.Title>{isBannerCreateMode ? "Add" : "Edit"} Banner</Modal.Title>
                                <IconButton onClick={handleCloseBannerForm}>
                                    <Close />
                                </IconButton>
                            </Modal.Header>
                            <Modal.Body>
                                <FormEditBannerService
                                    initialFormValues={initailBannerFormValues}
                                    onSubmit={
                                        isBannerCreateMode
                                            ? handleCreatePackagePromotionBanner
                                            : handleUpdatePackagePromotionBanner
                                    }
                                    onCancel={handleCloseBannerForm}
                                />
                            </Modal.Body>
                        </Modal>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
}
